import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes, faHome, faPodcast, faMusic, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF, faSoundcloud, faSpotify, faInstagram, faApple } from '@fortawesome/free-brands-svg-icons'
import { xml2json } from 'xml-js'
// import 'slick-carousel/slick/slick.css';


Vue.use(require('vue-moment'));

library.add(faBars, faTimes, faHome, faPodcast, faMusic, faPaperPlane, faFacebookF, faSoundcloud, faSpotify, faInstagram, faApple)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.prototype.$axios = axios;
Vue.prototype.$newsurl = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_HEADLINES_PROD : process.env.VUE_APP_HEADLINES;
Vue.prototype.$releases = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_SOUNDCLOUD_PROD : process.env.VUE_APP_SOUNDCLOUD;
Vue.prototype.$podcast = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_PODCAST_PROD : process.env.VUE_APP_PODCAST;
Vue.prototype.$posts = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_POSTS : process.env.VUE_APP_POSTS;
Vue.prototype.$xml2json = xml2json;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
